<div class="lum-modal">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">Sync Products</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <form
      [formGroup]="form"
      class="invoice-note-form__wrapper"
      (submit)="onSubmit()"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="">Select channels to sync</label>
            <mat-select
              class="lum-select"
              formControlName="channelIds"
              multiple
              [ngClass]="{
                error:
                  form.get('channelIds')?.invalid &&
                  form.get('channelIds')?.touched,
              }"
            >
              <mat-option
                *ngFor="let item of channels; trackBy: trackById"
                [value]="
                  hasChannelPushStockOms
                    ? item.pushStocksAppIntegrationAccountId
                    : item.id
                "
              >
                {{ item.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('channelIds')?.invalid">
              {{ form.get('channelIds') | validateField }}
            </mat-error>
          </div>
        </div>
      </div>
      <div *ngIf="!hasChannelPushStockOms" class="row">
        <div class="col-12">
          <div class="form-group flex gap-3">
            <label for="">Sync new products only</label>
            <mat-checkbox
              class="lum-checkbox"
              formControlName="isNewProducts"
            ></mat-checkbox>
          </div>
        </div>
      </div>
      <div class="lum-modal__footer">
        <div class="flex ml-auto lum-modal__action">
          <button
            mat-button
            type="submit"
            class="lum-button"
            [disabled]="form.invalid"
          >
            <lum-ui-icon
              icon="programming-cloud-download"
              color="#ffffff"
              width="14"
              height="14"
              class="mr-1"
            ></lum-ui-icon>
            Sync
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
